import { Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const TABS = ["overview", "applicant-form"] as const;
type TabType = (typeof TABS)[number];

const CandidateDetailsNavigation = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "candidateDetailsPage" });

  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get("tab") || "overview";

  const handleTabChange = (event: React.SyntheticEvent, newValue: TabType) => {
    const searchParams = new URLSearchParams(location.search);
    Array.from(searchParams.keys()).forEach((key) => {
      searchParams.delete(key);
    });
    searchParams.set("tab", newValue);

    navigate({ search: searchParams.toString() });
  };

  return (
    <Tabs value={currentTab} onChange={handleTabChange} aria-label="job overview tabs" sx={styles.tabs}>
      {TABS.map((tab) => (
        <Tab key={tab} label={t(tab)} value={tab} sx={styles.tabStyle} />
      ))}
    </Tabs>
  );
};

export default CandidateDetailsNavigation;

const styles = {
  tabs: {
    minHeight: "fit-content",
    borderBottom: "1px solid var(--Gray-200, #E4E7EC)",
    "& .MuiTabs-flexContainer": {
      gap: "24px",
    },
  },
  tabStyle: {
    fontFamily: "Montserrat",
    color: "var(--Gray-500, #667085)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    padding: "0px 4px 12px 4px",
    textTransform: "none",
    minHeight: "fit-content",
    minWidth: "fit-content",
  },
};
